// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flyout {\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.flyout > span {\n    cursor: pointer;\n    color: #777C7F;\n}\nul {\n  list-style: none;\n  font-size: 15px;\n}\nli a {\n  font-size: 15px;\n  font-weight: 600;\n  background-color: transparent;\n}\nli a.active {\n    color: #53dc86;\n}\n.icon {\n  position: relative;\n  top: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
